import {SC_Originator} from "../enums/SC_Originator";
import {SC_FMNote} from "./SC_FMNote";
import {SC_BasicNote} from "./SC_BasicNote";
import {SC_User} from "../SC_User";

export function SC_BasicNotefromAPI(jsonin: Record<string, any>, usersCache: SC_User[] = []): SC_BasicNote {
    let originator = SC_Originator.fromAPI(jsonin[SC_BasicNote.inputKeys.originator]);

    let out: SC_BasicNote;

    switch (originator.toAPI()) {
        case SC_Originator.FM_PILOT:
            out = SC_FMNote.fromApi(jsonin);
            break;
        default:
            out = new SC_BasicNote(SC_BasicNote.basicAPIStuff(jsonin));
            break;
    }

    if (usersCache)
        out.scavengeUsers(usersCache);

    return out;
}
